export default [
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/sft/About.vue'),
    },
  ]